import { Mic, X, MicOff } from "lucide-react";
import { useSelector } from "react-redux";
import React from "react";
import PropTypes from "prop-types";

const BottomControls = React.memo(function BottomControls({
  mode,
  onMic,
  onCancel,
}) {
  const isMicOn = useSelector((state) => state.voiceMode.isMicOn);

  return (
    <div className="w-full flex flex-col items-center pb-10 select-none">
      <div className="flex flex-row gap-6">
        <button
          className={`cursor-pointer rounded-full bg-[#1B5C29] flex items-center justify-center w-14 h-14 ${
            !isMicOn ? "bg-red-700/80" : ""
          }`}
          aria-label="Mic"
          onClick={onMic}
        >
          {!isMicOn ? (
            <MicOff className="text-white " size={28} />
          ) : (
            <Mic className="text-white" size={28} />
          )}
        </button>
        <button
          className="cursor-pointer rounded-full bg-[#1B5C2940] flex items-center justify-center w-14 h-14"
          aria-label="Cancel"
          onClick={onCancel}
        >
          <X className="text-[#1B5C29]" size={28} />
        </button>
      </div>
    </div>
  );
});

BottomControls.propTypes = {
  mode: PropTypes.string,
  onMic: PropTypes.func,
  onCancel: PropTypes.func,
};

export default BottomControls;
